if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

(() => {
  if (window.desktopGalleryFixLoaded) return;
  window.desktopGalleryFixLoaded = true;

  const instances = new WeakMap();
  const desktop = window.matchMedia('(min-width: 750px)');
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function init(root = document) {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (instances.has(gallery)) return;

      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const track = viewer?.querySelector('[id^="Slider-Gallery"]');
      const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
      const thumbList = thumbs?.querySelector('.thumbnail-list');

      if (!track || !thumbList || !gallery.setActiveMedia) return;

      const controller = new AbortController();
      const signal = controller.signal;

      const enabled = () =>
        desktop.matches &&
        gallery.dataset.desktopLayout?.includes('thumbnail');

      const behavior = () =>
        reducedMotion.matches ? 'auto' : 'smooth';

      let gesture = null;
      let suppressClickUntil = 0;
      let animation = null;

      function sizeGallery() {
  gallery.classList.toggle('desktop-gallery-fixed', enabled());

  if (!enabled()) {
    gallery.style.removeProperty('--gallery-rail-height');
    return;
  }

  const mainHeight = Math.round(
    track.getBoundingClientRect().height
  );

  if (mainHeight > 0) {
    const extraHeight = 100;

    gallery.style.setProperty(
      '--gallery-rail-height',
      `${mainHeight + extraHeight}px`
    );
  }
}

      const originalThumbnail = gallery.setActiveThumbnail;

      gallery.setActiveThumbnail = function (thumbnail) {
        if (!enabled()) {
          return originalThumbnail.call(this, thumbnail);
        }

        if (!thumbnail) return;

        thumbList
          .querySelectorAll('button[aria-current]')
          .forEach((button) => {
            button.removeAttribute('aria-current');
          });

        thumbnail
          .querySelector('button')
          ?.setAttribute('aria-current', 'true');

        const itemRect = thumbnail.getBoundingClientRect();
        const listRect = thumbList.getBoundingClientRect();

        if (
          itemRect.top < listRect.top ||
          itemRect.bottom > listRect.bottom
        ) {
          thumbList.scrollTo({
            top:
              thumbList.scrollTop +
              itemRect.top -
              listRect.top -
              (thumbList.clientHeight - itemRect.height) / 2,
            behavior: behavior()
          });
        }
      };

      function move(direction) {
        const items = [
          ...thumbList.querySelectorAll('[data-target]')
        ].filter(
          (item) =>
            item.getClientRects().length &&
            getComputedStyle(item).visibility !== 'hidden'
        );

        const active = track.querySelector('.is-active');

        const index = items.findIndex(
          (item) =>
            item.dataset.target === active?.dataset.mediaId
        );

        const target = items[index + direction];

        if (index < 0 || !target) return;

        gallery.setActiveMedia(target.dataset.target, false);

        const slide = [
          ...track.querySelectorAll('[data-media-id]')
        ].find(
          (item) =>
            item.dataset.mediaId === target.dataset.target
        );

        if (slide && !reducedMotion.matches) {
          animation?.cancel();

          animation = slide.animate(
            [
              {
                opacity: 0.55,
                transform: `translateX(${direction * 24}px)`
              },
              {
                opacity: 1,
                transform: 'translateX(0)'
              }
            ],
            {
              duration: 260,
              easing: 'ease-out'
            }
          );
        }

        requestAnimationFrame(sizeGallery);
      }

      gallery.addEventListener(
        'click',
        (event) => {
          if (!enabled()) return;

          if (
            track.contains(event.target) &&
            performance.now() < suppressClickUntil
          ) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          const button = event.target.closest('.slider-button');
          if (!button || !gallery.contains(button)) return;

          const direction = button.name === 'next' ? 1 : -1;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (thumbs.contains(button)) {
            thumbList.scrollBy({
              top: direction * thumbList.clientHeight * 0.75,
              behavior: behavior()
            });
          } else if (viewer.contains(button)) {
            move(direction);
          }
        },
        { capture: true, signal }
      );

      track.addEventListener(
        'pointerdown',
        (event) => {
          if (
            !enabled() ||
            event.button !== 0 ||
            !event.isPrimary
          ) {
            return;
          }

          if (
            event.target.closest(
              'deferred-media, model-viewer, video, iframe, a, input'
            )
          ) {
            return;
          }

          gesture = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            dragging: false
          };
        },
        { signal }
      );

      window.addEventListener(
        'pointermove',
        (event) => {
          if (!gesture || event.pointerId !== gesture.id) return;

          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;

          if (
            !gesture.dragging &&
            Math.abs(dy) > Math.abs(dx) &&
            Math.abs(dy) > 10
          ) {
            gesture = null;
            return;
          }

          if (Math.abs(dx) > 10) {
            gesture.dragging = true;
            track.classList.add('is-dragging');

            if (event.cancelable) event.preventDefault();
          }
        },
        { passive: false, signal }
      );

      function finish(event) {
        if (!gesture || event.pointerId !== gesture.id) return;

        const dx = event.clientX - gesture.x;
        const dragged = gesture.dragging;

        gesture = null;
        track.classList.remove('is-dragging');

        if (dragged) {
          suppressClickUntil = performance.now() + 400;

          if (
            event.type === 'pointerup' &&
            Math.abs(dx) >= 45
          ) {
            move(dx < 0 ? 1 : -1);
          }
        }
      }

      window.addEventListener('pointerup', finish, { signal });
      window.addEventListener('pointercancel', finish, { signal });

      track.addEventListener(
        'dragstart',
        (event) => {
          if (enabled() && event.target.closest('img')) {
            event.preventDefault();
          }
        },
        { signal }
      );

      desktop.addEventListener('change', sizeGallery, { signal });

      const observer = new ResizeObserver(sizeGallery);
      observer.observe(track);
      sizeGallery();

      instances.set(gallery, () => {
        controller.abort();
        observer.disconnect();
        animation?.cancel();

        gallery.setActiveThumbnail = originalThumbnail;
        gallery.classList.remove('desktop-gallery-fixed');

        instances.delete(gallery);
      });
    });
  }

  customElements.whenDefined('media-gallery').then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => init(),
        { once: true }
      );
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target
        .querySelectorAll('media-gallery')
        .forEach((gallery) => instances.get(gallery)?.());
    });
  });
})();